export default __webpack_public_path__ + "static/media/GalleryFirstSMCblackFullSize.7dd8dbb1.png";